import { defineMessages } from "react-intl";

export const refundGridMessages = defineMessages({
  statusCell: {
    defaultMessage: "Status",
    id: "8DyXiQ",
    description: "refund datagrid status column",
  },
  amountCell: {
    defaultMessage: "Amount",
    id: "W6VS7F",
    description: "refund datagrid amount column",
  },
  reasonCell: {
    defaultMessage: "Reason",
    id: "2v3tZ2",
    description: "refund datagrid reason column",
  },
  dateCell: {
    defaultMessage: "Date",
    id: "pnPj0b",
    description: "refund datagrid date column",
  },
  accountCell: {
    defaultMessage: "Account",
    id: "JxWKvr",
    description: "refund datagrid account column",
  },
  addNewRefund: {
    defaultMessage: "Add new refund",
    id: "4XRIV5",
    description: "add new refund button",
  },
  refundSection: {
    defaultMessage: "Refunds",
    id: "w067gF",
    description: "refund section header",
  },
  noRefunds: {
    defaultMessage: "No refunds made for this order.",
    id: "ZU1Kz8",
    description: "empty state message",
  },
});
